<template>
  <Card class="card-investor" :link="url">
    <div slot="header">
      <div
        class="card-logo"
        :style="{ backgroundImage: 'url(' + investor.logoImageUrl + ')' }"
      ></div>

      <h4 slot class="card-title">{{ investor.name }}</h4>
    </div>

    <div class="card-content">
      <p>{{ investor.intro }}</p>
    </div>

    <div slot="footer">
      <div class="card-footer">
        <div class="card-footer-category">
          {{
            this.$store.getters['meta/investorCategoryLabelByValue'](
              investor.category
            )
          }}
        </div>
        <div
          v-if="user && user.isAdmin && investor.views.week > 0"
          class="card-footer-views"
        >
          {{ investor.formattedViews.week }}
        </div>
      </div>
    </div>
  </Card>
</template>

<script>
import Card from '@/components/Card'

export default {
  name: 'FundingListItem',
  components: {
    Card
  },
  props: {
    investor: {
      type: Object,
      required: true
    }
  },
  computed: {
    user() {
      return this.$store.state.user.data
    },
    url() {
      if (this.$route.path.includes('/client')) {
        return (
          '/client/startups/' +
          this.$route.params.company +
          '/funding/' +
          this.investor.key
        )
      }

      return this.investor.url
    }
  }
}
</script>

<style lang="scss" scoped>
.card-investor {
  .card-logo {
    height: rem(100px);
    width: rem(100px);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    margin-bottom: rem(48px);
  }

  .card-title {
    padding: 0 0 rem(14px) 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .card-content {
    padding-bottom: rem(24px);

    p {
      font-size: rem(14px);
      color: $gray-700;
      line-height: 1.5;
      height: rem(84px);
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
    }
  }
  .card-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .card-footer-category {
      font-weight: bold;
      font-size: rem(16px);
    }
    .card-footer-views {
      display: inline-block;
      color: $blue-900;
      font-weight: 700;
      background-color: transparentize($blue-900, 0.9);
      padding: rem(6px) rem(14px);
      margin: rem(-10px) 0;
    }
  }
}
</style>
